export default {
  heading: "Can't connect as session limit exceeded",
  subheading:
    'You have exceeded the maximum number of concurrent sessions allowed for a Flock account. Please sign out of unwanted sessions to connect successfully on this device.',
  try_again: 'Try again',
  manage_sessions: 'Manage my sessions',
};
